// HinweisToast.tsx — kleiner, selbstschließender Status-Hinweis für den
// Kalender-Neubau (Termine-SP2, Review 2026-07-07): sichtbares Feedback statt
// stillem No-Op, wenn eine Aktion nicht möglich ist (z. B. kein Kalender mit
// Schreibzugriff). Bewusst OHNE Fluent (cal-rd-Bereich, Refined-Stil) und ohne
// window.alert; fixed unten zentriert, role="status" für Screenreader.

import React, { useCallback, useEffect, useRef, useState } from "react";
import { REFINED } from "../risikoanalyseStep/tokens";

/** Anzeigedauer, danach blendet der Hinweis von selbst aus. */
const HINWEIS_DAUER_MS = 4000;

/** State + Trigger für den Hinweis (Timer wird bei Re-Trigger neu gestartet). */
export function useHinweisToast(): {
    hinweis: string | null;
    zeigeHinweis: (text: string) => void;
} {
    const [hinweis, setHinweis] = useState<string | null>(null);
    const timerRef = useRef<number | null>(null);
    const zeigeHinweis = useCallback((text: string) => {
        setHinweis(text);
        if (timerRef.current) window.clearTimeout(timerRef.current);
        timerRef.current = window.setTimeout(() => {
            timerRef.current = null;
            setHinweis(null);
        }, HINWEIS_DAUER_MS);
    }, []);
    // Unmount räumt einen laufenden Timer ab.
    useEffect(
        () => () => {
            if (timerRef.current) window.clearTimeout(timerRef.current);
        },
        [],
    );
    return { hinweis, zeigeHinweis };
}

/** Rendert den Hinweis (null ⇒ nichts) — fixed unten zentriert, über allem. */
export const HinweisToast: React.FC<{ text: string | null }> = ({ text }) => {
    if (!text) return null;
    return (
        <div role="status" style={toastStyle}>
            {text}
        </div>
    );
};

const toastStyle: React.CSSProperties = {
    position: "fixed",
    left: "50%",
    bottom: 28,
    transform: "translateX(-50%)",
    maxWidth: "min(92vw, 480px)",
    padding: "10px 18px",
    borderRadius: 10,
    background: REFINED.ink,
    color: REFINED.white,
    font: `600 13px ${REFINED.fontUI}`,
    boxShadow: "0 6px 24px rgba(0, 0, 0, 0.25)",
    zIndex: 100000,
    textAlign: "center",
};

export default HinweisToast;
